import React from "react";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import FilterableList from "components/ListOption/FilterableList";

import { useAppMeta } from "hooks";

import { GLOBAL_LIST_OPTIONS } from "data/static";

const GlobalListOptionScreen = () => {
  const breadcrumbs = [{ title: "Global List" }];

  useAppMeta("Global List");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs}>
      <BreadcrumbLayout.Paper>
        <FilterableList title="Global List" list={GLOBAL_LIST_OPTIONS} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default GlobalListOptionScreen;
